// Browser-only helper that captures ?promo=CODE from landing URL and stashes
// it in sessionStorage so checkout can pre-apply it via Stripe `discounts[]`.
// Mirrors src/lib/refParam.ts.
const KEY = "knowmeno_promo";

// Stripe promotion codes are typically [A-Z0-9_-], 1-50 chars. We accept a
// liberal set and let Stripe reject invalid codes at checkout time.
function isPlausiblePromoCode(code: string): boolean {
  return /^[A-Z0-9_\-]{1,50}$/i.test(code);
}

export function capturePromoParam(): void {
  if (typeof window === "undefined") return;
  try {
    const params = new URLSearchParams(window.location.search);
    const promo = params.get("promo");
    if (promo && isPlausiblePromoCode(promo)) {
      window.sessionStorage.setItem(KEY, promo.toUpperCase());
    }
  } catch {
    // ignore
  }
}

export function getPendingPromo(): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function clearPendingPromo(): void {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
